<div class="d-flex flex-column h-100">
  <div mat-dialog-title>
    <div>
      <div data-testId="title" class="h4 mb-0">{{data.title}}</div>
      <div
        data-testId="description"
        class="text-muted extraData"
        i18n="@@dprDetails.dprImportActivitiesDialog.txtInfoMessage"
      >
        Copy/paste and/or manually enter data to be imported.
      </div>
    </div>
    <button data-testId="close" mat-icon-button class="align-self-start mt-1" (click)="onCancel()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <!-- This validation message needs to be placed outside the dialog content so that the table dimensions can be properly adjusted. -->
  <div *ngIf="hasValidationErrors$ | async" class="d-flex error-div mt-3 mx-3">
    <mat-icon svgIcon="information-outline" class="d-flex"></mat-icon>
    <span class="d-flex font-weight-bold">{{ getErrorMessage }}</span>
  </div>

  <div
    *ngIf="exceededNumberOfColumnsErrors$ | async"
    class="d-flex error-div mx-3"
    [ngClass]="hasValidationErrors$.value ? 'mt-2' : 'mt-3'"
  >
    <mat-icon svgIcon="information-outline" class="d-flex"></mat-icon>
    <span class="d-flex font-weight-bold">{{ exceededNumberOfColumnsError }}</span>
  </div>

  <div mat-dialog-content class="d-flex flex-column px-3 py-3 overflow-hidden">
    <div class="w-100 h-100" #jspreadsheet></div>
  </div>

  <div mat-dialog-actions class="d-flex">
    <button data-testId="insert" mat-flat-button color="primary" (click)="onInsert()" cdkFocusInitial>
      <mat-icon svgIcon="check"></mat-icon>
      <span>{{StaticMessage.InsertButton | staticMessage}}</span>
    </button>
    <button data-testId="cancel" mat-button color="primary" (click)="onCancel()">
      {{StaticMessage.CancelButton | staticMessage}}
    </button>
  </div>
</div>
